if (!customElements.get('blog-grid')) {
  class BlogGrid extends HTMLElement {
    constructor() {
      super();

      this.activeTag = null;
      this.abortController = null;
      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.blogHandle = this.dataset.blogHandle;
      this.blogGridElement = this.querySelector('[data-blog-grid]');
      this.paginationElement = this.querySelector('[data-blog-paginate]');

      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      const tagElement = event.target.closest('[data-tag]');
      const paginationLink = event.target.closest('[data-blog-paginate] a');

      if (tagElement) {
        event.preventDefault();
        const tag = tagElement.dataset.tag;
        this.activeTag = this.activeTag === tag ? null : tag;
        this.fetchSection(this.buildUrl(this.activeTag));
        return;
      }

      if (paginationLink) {
        event.preventDefault();
        this.fetchSection(paginationLink.href, true);
      }
    }

    buildUrl(tag) {
      const base = tag
        ? `/blogs/${this.blogHandle}/tagged/${tag}`
        : `/blogs/${this.blogHandle}`;
      return base;
    }

    async fetchSection(url, scrollToGrid) {
      this.abortController?.abort();
      this.abortController = new AbortController();

      this.classList.add('blog-grid--loading');

      const fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('sections', this.sectionId);

      try {
        const response = await fetch(fetchUrl.href, { signal: this.abortController.signal });
        if (!response.ok) throw new Error(response.statusText);

        const payload = await response.json();
        const sectionHtml = payload[this.sectionId];

        const parsedHtml = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const incomingBlogGrid = parsedHtml.querySelector('[data-blog-grid]');
        const incomingPagination = parsedHtml.querySelector('[data-blog-paginate]');

        this.blogGridElement.innerHTML = incomingBlogGrid.innerHTML;
        this.paginationElement.innerHTML = incomingPagination.innerHTML;

        if (scrollToGrid) {
          this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        if (this.activeTag) {
          this.querySelectorAll('[data-tag]').forEach((element) => {
            element.classList.toggle('blog-grid__tag--active', element.dataset.tag === this.activeTag);
          });
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error('[blog-grid] fetch failed:', error);
      } finally {
        this.classList.remove('blog-grid--loading');
      }
    }
  }

  customElements.define('blog-grid', BlogGrid);
}
